var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.133,
    height: 120,
    viewBox: "0 0 137.133 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "triangle-exclamation-solid",
    d: "M68.6,32a10.693,10.693,0,0,1,9.241,5.3L135.7,135.875A10.708,10.708,0,0,1,126.456,152H10.741A10.708,10.708,0,0,1,1.5,135.875L59.357,37.3A10.693,10.693,0,0,1,68.6,32Zm0,34.286a6.413,6.413,0,0,0-6.429,6.429v30a6.429,6.429,0,1,0,12.857,0v-30A6.413,6.413,0,0,0,68.6,66.286Zm8.571,60a8.571,8.571,0,1,0-8.571,8.571A8.562,8.562,0,0,0,77.17,126.286Z",
    transform: "translate(-0.037 -32)",
    fill: "#b2b1b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.554f73d796ee56db972807169bff28de.svg";
export { ForwardRef as ReactComponent };